import moment from "moment";

export function formUrlQuery(obj) {
  let queryString = '';
  for (let key in obj) {
    if (obj[key].toString() && obj[key].toString() != '') {
      if (queryString.length > 0) {
        queryString += '&';
      }
      queryString += `${key}=${obj[key]}`;
    }
  }
  return queryString;
}

export function formSortQuery(obj) {
  let querySort = 'id%desc';
  if (
    obj &&
    obj.column &&
    obj.state &&
    obj.column !== "" &&
    obj.state !== "" &&
    obj.state != 0
  ) {
    querySort = `${obj.column}%${obj.state}`
  }
  return querySort;
}

export function formBookingListFilterQuery(obj) {
  let objFilter = {};

  const filterBookingStatus = obj && obj.booking_status
  const filterServicePackage = obj && obj.package_id
  const filterPaymentMethod = obj && obj.payment_method_id
  const filterBookingAmount = obj && obj.booking_amount
  const filterStartCreatedDate = obj && obj.start_created_date
  const filterEndCreatedDate = obj && obj.end_created_date
  const filterStartBookingDate = obj && obj.start_booking_date
  const filterEndBookingDate = obj && obj.end_booking_date

  // filter booking status
  if (filterBookingStatus && filterBookingStatus !== '') {
    objFilter.booking_status = filterBookingStatus
  }

  // filter service package
  if (filterServicePackage && filterServicePackage !== '') {
    objFilter.package_id = filterServicePackage
  }

  // filter payment method
  if (filterPaymentMethod && filterPaymentMethod !== '') {
    objFilter.payment_method_id = filterPaymentMethod
  }

  // filter booking amount
  if (filterBookingAmount && filterBookingAmount !== '') {
    objFilter.booking_amount = filterBookingAmount.split(" - ").join("-")
  }

  // filter created date
  if (filterStartCreatedDate && filterStartCreatedDate !== '' && filterEndCreatedDate && filterEndCreatedDate !== '') {
    objFilter.start_created_date = moment(filterStartCreatedDate).format("YYYY-MM-DD")
    objFilter.end_created_date = moment(filterEndCreatedDate).format("YYYY-MM-DD")
  }

  // filter booking date
  if (filterStartBookingDate && filterStartBookingDate !== '' && filterEndBookingDate && filterEndBookingDate !== '') {
    objFilter.start_booking_date = moment(filterStartBookingDate).format("YYYY-MM-DD")
    objFilter.end_booking_date = moment(filterEndBookingDate).format("YYYY-MM-DD")
  }

  return objFilter;
}